const PRODUCTION_HOSTNAME = 'app.onesupporthub.com';

const { protocol, hostname } = window.location;

const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

const HOME_URL = isLocalhost
  ? 'http://localhost:3000'
  : `https://${PRODUCTION_HOSTNAME}`;

const API_BASE_URL = isLocalhost
  ? 'http://localhost:3003'
  : `https://${PRODUCTION_HOSTNAME}`;

const ZOOM_APP_AUTH_ENDPOINT = 'http://localhost:4000';

const JITSI_BASE_URL =  'https://meet.onesupporthub.com'; 

const PROFILE_IMAGES_URL = `https://${PRODUCTION_HOSTNAME}/osh-data/profile-images`;
const AVATAR_DEFAULT_URL = '/images/avatar.jpg';

const ATTACHMENTS_BASE_URL = `https://${PRODUCTION_HOSTNAME}/osh-data/attachments`;

function toWebSocketProtocol(url) {
  return url.replace(/^http/, 'ws');
}

const config = {
  HOME_URL,

  API_BASE_URL,

  ZOOM_APP_AUTH_ENDPOINT,

  JITSI_BASE_URL,

  PROFILE_IMAGES_URL,
  AVATAR_DEFAULT_URL,

  ATTACHMENTS_BASE_URL,

  BASE_ACCOUNT_ROUTE: '/account',
  ADMIN_ACCOUNT_ROUTE: '/account/admin-dashboard',
  PS_ACCOUNT_ROUTE: '/account/ps-dashboard',
  FS_ACCOUNT_ROUTE: '/account/fs-dashboard',
  PS_PROFILE_ROUTE: '/account/ps-dashboard/profile',

  get WS_BASE_URL() {
    return toWebSocketProtocol(API_BASE_URL);
  },

  get ADMIN_USER_SOCKET_URL() { return `${this.WS_BASE_URL}/ws/admin-users`; },
  get CLIENT_USER_SOCKET_URL() { return `${this.WS_BASE_URL}/ws/client-users`; },
  get WORKER_USER_SOCKET_URL() { return `${this.WS_BASE_URL}/ws/worker-users`; },
  get CLAIM_SOCKET_URL() { return `${this.WS_BASE_URL}/ws/osh-claims`; },
  get MESSAGE_SOCKET_URL() { return `${this.WS_BASE_URL}/ws/messages`; },

  get BROADCAST_SOCKET_URL() {
    return `${this.API_BASE_URL}/ws-broadcast`;
  },
};

export default config;

